module.exports = __webpack_public_path__ + "static/media/pistol-poem.626d1546.txt";